export const FeatureFlags = {
  INVESTMENTS: 'investments',
  TEST_NOTIFICATIONS: 'test_notifications',
  ALLOW_REGISTRATION: 'allow-registration',
  CONVERT_ACCOUNT_TO_CREDIT: 'convert_account_to_credit',
  TRADING_BOT: 'trading_bot',
  DAY_TRADE_BACKTEST: 'day_trade_backtest',
  DAY_TRADE_BOT: 'day_trade_bot',
  DIP_PIPELINE_PLAYGROUND: 'dip_pipeline_playground',
  // value carries the mock T-Bank gRPC address (host:port). present => the backend talks to that
  // mock instead of the broker; absent => business as usual. see
  // packages/backend/src/investments/tbank-mode.ts, which must use the identical literal.
  TBANK_MOCK_ENDPOINT: 'tbank_mock_endpoint',
} as const

export type FeatureFlagName = (typeof FeatureFlags)[keyof typeof FeatureFlags]

export type FeatureFlagScope = 'global' | 'targeted'

export interface FeatureFlagMeta {
  scope: FeatureFlagScope
  usesValue: boolean
}

// registry of known-to-the-code flags and their configuration surface.
// flags not listed here default to targeted + usesValue.
export const featureFlagMeta: Record<FeatureFlagName, FeatureFlagMeta> = {
  [FeatureFlags.INVESTMENTS]: { scope: 'targeted', usesValue: true },
  [FeatureFlags.TEST_NOTIFICATIONS]: { scope: 'targeted', usesValue: false },
  [FeatureFlags.ALLOW_REGISTRATION]: { scope: 'global', usesValue: false },
  [FeatureFlags.CONVERT_ACCOUNT_TO_CREDIT]: { scope: 'targeted', usesValue: false },
  [FeatureFlags.TRADING_BOT]: { scope: 'targeted', usesValue: false },
  [FeatureFlags.DAY_TRADE_BACKTEST]: { scope: 'targeted', usesValue: false },
  [FeatureFlags.DAY_TRADE_BOT]: { scope: 'targeted', usesValue: false },
  [FeatureFlags.DIP_PIPELINE_PLAYGROUND]: { scope: 'targeted', usesValue: false },
  // global, not targeted: the backend resolves this once per process and only honours the
  // all-scope row, so a per-role or per-user copy would be silently ignored. `global` makes the
  // dialog force empty targeting, which is exactly the row shape the resolver looks for.
  [FeatureFlags.TBANK_MOCK_ENDPOINT]: { scope: 'global', usesValue: true },
}

export const defaultFeatureFlagMeta: FeatureFlagMeta = { scope: 'targeted', usesValue: true }

export const getFeatureFlagMeta = (name: string): FeatureFlagMeta =>
  featureFlagMeta[name as FeatureFlagName] ?? defaultFeatureFlagMeta
